import { DepositsStatusEnum } from '../../../core/enums/tabs-deposits.enum';

function getCellStylesByStatus() {
  const colors = {red: 'red', green: 'green', yellow: '#ff8c04', black: 'black'};
  const aligns = {start: 'start'};
  const weights = {bold: 'bold', normal: 'normal'};
  const borderStyle = '1px dotted #dee2e6';

  const normalStyles = {
    'text-align': aligns.start,
    color: colors.black,
    'font-weight': weights.normal,
    'border-top': borderStyle,
    'border-bottom': borderStyle
  };

  const dangerStyles = {
    'text-align': aligns.start,
    color: colors.red,
    'font-weight': weights.bold,
    'border-top': borderStyle,
    'border-bottom': borderStyle
  };

  const warningStyles = {
    'text-align': aligns.start,
    color: colors.yellow,
    'font-weight': weights.bold,
    'border-top': borderStyle,
    'border-bottom': borderStyle
  };

  const successStyles = {
    'text-align': aligns.start,
    color: colors.green,
    'font-weight': weights.bold,
    'border-top': borderStyle,
    'border-bottom': borderStyle
  };

  const stylesByPosted = (statusId: number) => {
    switch (statusId) {
      case DepositsStatusEnum.Pending:
        return dangerStyles;
      case DepositsStatusEnum.OverPosted:
        return warningStyles;
      case DepositsStatusEnum.Posted:
        return successStyles;
      case DepositsStatusEnum.Incomplete:
        return warningStyles;
      default:
        return normalStyles;
    }
  };

  const stylesByDeposit = (statusId: number) => {
    switch (statusId) {
      case DepositsStatusEnum.Pending:
        return dangerStyles;
      case DepositsStatusEnum.OverPosted:
        return warningStyles;
      case DepositsStatusEnum.Completed:
        return successStyles;
      case DepositsStatusEnum.Incomplete:
        return warningStyles;
      default:
        return normalStyles;
    }
  };

  return { stylesByDeposit, stylesByPosted };
}

export { getCellStylesByStatus }



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/deposits/helper.ts